import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import cofocusPreferences from "./modules/cofocusPreferences";
import community from "./modules/community";
import indicators from "./modules/indicators";
import mediastates from "./modules/mediastates";
import messages from "./modules/messages";
import preferences from "./modules/preferences";
import roomlogs from "./modules/roomlogs";
import style from "./modules/style";
import integrations from "./modules/integrations";
import onboarding from "./modules/onboarding";
import notices from "./modules/notices";
import modals from "./modules/modals";
import notifier from "./modules/notifier";
import userstats from "./modules/userstats";
import properties from "./modules/properties";
import survey from "./modules/survey";

import calendarUsers from "./calendar/modules/calendarUsersModule";
import pastMatches from "./calendar/modules/pastMatchesModule";
import upcomingMatches from "./calendar/modules/upcomingMatchesModule";
import matchPool from "./calendar/modules/matchPoolUsersModule";
import calendar from "./calendar/modules/calendarModule";
import selections from "./calendar/modules/selectionsModule";

import room from "./session/room";
import roomLoading from "./session/roomLoading";
import session from "./session/session";
import toolbar from "./session/toolbar";
import rematching from "./session/rematching";
import remoteProfileData from "./session/remoteProfileData";
import sessionState from "./session/sessionState";

/* ====== WORKSPACES ====== */
import workspace from "./workspaces/workspace";
import openArea from "./workspaces/openArea";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    cofocusPreferences,
    community,
    indicators,
    mediastates,
    messages,
    preferences,
    roomlogs,
    integrations,
    onboarding,
    notices,
    modals,
    notifier,
    userstats,
    properties,
    survey,

    calendar,
    calendarUsers,
    pastMatches,
    upcomingMatches,
    matchPool,
    selections,
    style,

    room,
    roomLoading,
    session,
    toolbar,
    rematching,
    remoteProfileData,
    sessionState,

    workspace,
    openArea,
  },

  // To ensure we get errors in dev (for better debugging) but not in production
  // If app is slow in testing, just comment this line out to see the real speed!
  // https://forum.vuejs.org/t/adding-many-objects-to-vuex-state-is-slow/10492/10

  // strict: process.env.NODE_ENV !== "production",
});

export default store;
